import { Locale } from './brand-config';

export interface UserPreferences {
  locale: Locale;
  theme: string;
  reverseMouseScrollDirection: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention -- intentional naming to avoid clashes
  __fallbackLocale?: Locale;
}
